import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from '../auth/AuthProvider'
import { DirtyProvider } from '../hooks/useDirty'
import { NotificationsProvider } from '../context/NotificationsContext'
import { appRoutes } from './routes'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 30_000,
    },
  },
})

const router = createBrowserRouter(appRoutes)

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <NotificationsProvider>
          <DirtyProvider>
            <RouterProvider router={router} />
          </DirtyProvider>
        </NotificationsProvider>
      </AuthProvider>
    </QueryClientProvider>
  )
}
